module.exports = __webpack_public_path__ + "img/about-bg.71457979.png";